import { render } from "./AIMatching.vue?vue&type=template&id=e5d0a9b2"
import script from "./AIMatching.vue?vue&type=script&lang=js"
export * from "./AIMatching.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__